import Vue from 'vue';
import BelegnummerkreisService from './belegnummerkreise.service';
import * as _ from 'lodash';
import abstractStore from '@/store/abstractstore';

export const getDefaultSort = () => ({ currentSort: 'id', currentSortDir: 'asc' });

const getDefaultItem = () => ({
    id: null,
    belegsTyps: [],
    nummernkreisPattern: '%2$tY1%05d',
    lastNummer: null,
    nummerProJahr: false,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    ...abstractStore.getAbstractValue(getDefaultSort().currentSort, getDefaultSort().currentSortDir),
});

const belegnummerkreise = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await BelegnummerkreisService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await BelegnummerkreisService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await BelegnummerkreisService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            if ((params && params.params && params.params.init) === true && params.params.page === 0 && context.rootState.belegnummerkreise.currentPage !== 0) {
                params.params.page = context.rootState.belegnummerkreise.currentPage;
            }
            const { headers, data } = await BelegnummerkreisService.query(params);

            data.forEach((field) => {
                let belegsTypsString = '';
                field.belegsTyps.forEach((value) => {
                    const capitalizedString = _.capitalize(value);
                    if (belegsTypsString.length > 0) {
                        belegsTypsString += ', ';
                    }
                    belegsTypsString += capitalizedString;
                });
                field.belegsTypsString = belegsTypsString;
            });

            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));

            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await BelegnummerkreisService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default _.merge(belegnummerkreise, abstractStore.getDefaultStore());
